var map = {
	"./ACTIVITIES.jpg": 88887,
	"./ATTRACTION.jpg": 65391,
	"./BARS.jpg": 38458,
	"./ENTERTAINMENT.jpg": 3904,
	"./TOURS.jpg": 59935,
	"./TRANSPORTATION.jpg": 8866
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8911;